export default __webpack_public_path__ + "static/media/video8.b4c7a4cf.mp4";